import BaseEventsTracking from './baseEventsTracking';

/**
 * Event logger for producing funnel events.
 *
 * @constructor
 * @param {string} environment The environment to log to. Can be either public or public-sandbox
 * @param {string} component The name of the service that is logging the events
 */
export default class FunnelEventsTracking extends BaseEventsTracking {
  constructor(environment, component, options) {
    super(environment, component, options);
    this.eventName = 'funnel_events';
  }

  async track(fullSchemaName, message, opts = {}) {
    return this.trackEvent(this.eventName, fullSchemaName, message, opts);
  }

  async trackBatch(fullSchemaName, message, opts = {}) {
    return this.trackBatchEvent(this.eventName, fullSchemaName, message, opts);
  }
}
